'use client'

import { useBagTotalItems } from 'cart/hooks/queries/useBagTotalItems'
import { useAnalytics } from 'cart/hooks/useAnalytics'
import { cx } from 'classix'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { replacePlaceholders } from 'labels/lib/replacePlaceholders'
import styles from './TotalItems.module.css'

interface Props {
	readonly withLabel?: boolean
	readonly manageFocus?: (itemRemoved: boolean) => void
	readonly icon?: boolean
	readonly inverse?: boolean
}

export const TotalItems = ({ withLabel, icon, inverse = false }: Props) => {
	const { t } = useLabels()
	const { sendBagErrorTotalItemsEvent } = useAnalytics()
	const { totalItems } = useBagTotalItems({
		errorCallback: sendBagErrorTotalItemsEvent,
	})

	const buttonClassName = withLabel ? undefined : styles.small

	const headerCartText: string =
		totalItems === undefined
			? ''
			: replacePlaceholders(t('header.shoppingBag.placeholder'), {
					1: totalItems || 0,
				})

	return (
		<span
			data-testid='bag.header.totalItems'
			className={cx(buttonClassName, inverse && styles.inverse)}
		>
			{icon ? totalItems : headerCartText}
		</span>
	)
}
